import { FC, useEffect, ReactNode } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { RootState, AppDispatch } from '../store'
import { getCurrentUser, validateToken } from '../store/slices/authSlice'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>()
  const { isAuthenticated, isLoading, user, token } = useSelector((state: RootState) => state.auth)

  useEffect(() => {
    // If we have a token but are not authenticated, validate the token
    if (token && !isAuthenticated && !isLoading) {
      dispatch(validateToken())
    }
    // If we have a token and are authenticated but no user data, fetch user info
    else if (isAuthenticated && !user && !isLoading) {
      dispatch(getCurrentUser())
    }
  }, [dispatch, isAuthenticated, user, isLoading, token])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
